(ns web3.persistence.local
  (:require [re-frame-simple.db :as db]
            [reagent.ratom :as rr]
            [re-frame.core :as rf]
            [web3.persistence.transit :as t]
            [applied-science.js-interop :as j]
            [goog.object :as gobj]))

(defn local-id [k]
  (str "centriq.local/" (t/serialize k)))

(defn local-get [k]
  (some-> (gobj/get js/window "localStorage")
          (gobj/get (local-id k))
          (t/deserialize)))

(rf/reg-cofx
 :local/get
 (fn [cofx k]
   (assoc cofx k (local-get k))))

(defn local-assoc!
  [k data]
  (gobj/set (.-localStorage js/window) (local-id k) (t/serialize data)))


(defn local-dissoc!
  "Translates the k to a local-id and then calls .removeItem on that k"
  [k]
  (j/call-in js/window
             [:localStorage :removeItem]
             (local-id k)))

(rf/reg-fx
 :local/assoc
 (fn [m]
   (doseq [[id val] m]
     (local-assoc! id val))))

(rf/reg-fx
 :local/dissoc
  (fn [ks]
      (let [ks (if (seqable? ks) ks
                                 [ks])]
        (doseq [k ks]
          (local-dissoc! k)))))

(comment ;;Re-frame event to test local-dissoc fx
 (rf/reg-event-fx :tmp
   (fn [cofx [_ ks]]
     {:local/dissoc ks})))

(defn local-update! [k f & args]
  (local-assoc! k (apply f (local-get k) args)))

(rf/reg-fx
 :local/update
 (fn [[k f & args]]
   (apply local-update! k f args)))

(def init-storage
  "Given a path into re-frame-db, initialize a local-storage backed source.

  after `init-storage`, the value for `path` is saved in the db, and
  whenever this value is mutated, the latest value is saved to localStorage."
  (memoize (fn
             ([path]
              (let [value (local-get path)]
                (db/dispatch-sync [:assoc-in path (local-get path)])
                (rr/run!
                 ;; write value to localStorage when it changes in re-frame
                 (let [db-value (db/get-in path)]
                   (local-assoc! path db-value))
                 :auto-run true)
                value))
             ([path initial-content]
              (when (and (nil? (local-get path)) initial-content)
                (local-assoc! path initial-content))
              (init-storage path)))))

(comment

 (init-storage [:a])

 (db/dispatch-sync [:assoc-in [:a] 11])
 (rr/flush!)
 (assert (= 11
            (local-get [:a])
            (db/get-in [:a])))

 (doseq [n [0 1 2 3 4]]
   (db/dispatch-sync [:assoc-in [:a] n]))
 (rr/flush!)
 (assert (= 4
            (local-get [:a])
            (db/get-in [:a]))))
